import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './Container.module.scss';
import { BRAND } from '../../constants/brand';

interface ContainerProps {
  className?: string;
}

const Container: FunctionComponent<ContainerProps> = ({
  children,
  className,
}) => {
  const containerClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-container`,
    className,
    {
      [styles.container]: true,
    },
  );

  return <div className={containerClass}>{children}</div>;
};

export default Container;
